import { formModeEnum } from '@/types/general';

import { settingsBreadcrumbs } from '../settings-breadcrumbs';

const teamsCrumb = {
  label: 'global.sidebar.teams_trans',
  route: { name: 's-teams' },
};

const teams_routes = [
  {
    path: 'teams',
    name: 'teams',
    redirect: { name: 's-teams' },
    meta: {
      permissions: 'read-teams',
    },
    children: [
      {
        path: '',
        name: 's-teams',
        component: () => import('@/views/System/Settings/Teams/TeamsList.vue'),
        meta: {
          permissions: 'read-teams',
          breadcrumbs: settingsBreadcrumbs(teamsCrumb),
        },
      },
      {
        path: 'add',
        name: 's-teams-add',
        component: () => import('@/views/System/Settings/Teams/Components/TeamForm.vue'),
        meta: {
          formType: formModeEnum.ADD,
          permissions: 'write-teams',
          breadcrumbs: settingsBreadcrumbs(teamsCrumb),
        },
      },
      {
        path: ':id',
        name: 's-teams-edit',
        component: () => import('@/views/System/Settings/Teams/Components/TeamForm.vue'),
        meta: {
          formType: formModeEnum.EDIT,
          permissions: 'update-teams',
          breadcrumbs: settingsBreadcrumbs(teamsCrumb),
        },
      },
    ],
  },
];

export default teams_routes;
